module.exports = __webpack_public_path__ + "static/plain-regular-12c2315acead1374e736d4ebb9ff6d69.woff2";